import { render, staticRenderFns } from "./SpeedAccusationLocation.vue?vue&type=template&id=50d8b9d6&"
import script from "./SpeedAccusationLocation.vue?vue&type=script&lang=js&"
export * from "./SpeedAccusationLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports